import { render, staticRenderFns } from "./AddonsList.vue?vue&type=template&id=2db04893&scoped=true"
import script from "./AddonsList.vue?vue&type=script&lang=js"
export * from "./AddonsList.vue?vue&type=script&lang=js"
import style0 from "./AddonsList.vue?vue&type=style&index=0&id=2db04893&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db04893",
  null
  
)

export default component.exports